import { CenteredText } from 'ui/components';

export const CenteredTextFeature: React.FC<Content.CenteredText> = ({ content, settings }) => <CenteredText 
        {...content?.properties} {...settings?.properties}
    />



